import { GetCustomizeCar_customizeCar_prices_totalFeatures } from '../../graphql/queries/__generated__/GetCustomizeCar';
import usePrice from '../../../gqlCommon/hooks/prices/usePrice';

const useTotalFeatures = (totalFeatures: GetCustomizeCar_customizeCar_prices_totalFeatures[]) => {
  const { primaryPrice: primaryTotalFeaturesPrices, secondaryPrice: secondaryTotalFeaturesPrices } =
    usePrice(totalFeatures);

  const totalFeaturesPrices = [primaryTotalFeaturesPrices, secondaryTotalFeaturesPrices];

  return { totalFeaturesPrices };
};

export default useTotalFeatures;
